import Datatable from "@components/datatable";
import usePublisherRouteGuard from "../use-publisher-route-guard";
import useEarningsTable from "./hooks/use-earnings-table";
import InvoiceConfirmModal from "./components/invoice-confirm-modal";
import { INVOICE_ACCEPT_ATTR } from "./misc/constants";

const PublisherEarnings = () => {
    const { publisherId } = usePublisherRouteGuard();
    const { loading, rows, columns, inputProps, confirmModal } = useEarningsTable(publisherId);

    return (
        <div className="p-6">
            <h1 className="text-2xl font-semibold tracking-tight">Earnings</h1>

            <div className="mt-4 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                <div className="border-b border-gray-100 p-4 text-sm font-semibold text-gray-900">Monthly breakdown</div>
                <Datatable
                    columns={columns}
                    data={rows}
                    loading={loading}
                    customNoData={<span className="text-sm text-muted">No earnings recorded yet.</span>}
                />
            </div>

            {/* One picker for every row — the row it was opened for is tracked
                in the hook until the file lands. */}
            <input {...inputProps} accept={INVOICE_ACCEPT_ATTR} className="hidden" />

            <InvoiceConfirmModal {...confirmModal} />
        </div>
    );
};

export default PublisherEarnings;
